import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { CheckCircle2 } from 'lucide-react';
export function ProductPresentation() {
  return <SectionWrapper bgColor="cream" data-id="element-212">
      <div className="text-center mb-8" data-id="element-213">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark mb-4 leading-tight" data-id="element-214">
          Presentando el Sistema Que Lo Cambia Todo
        </h2>
      </div>

      <div className="bg-white rounded-3xl shadow-soft overflow-hidden mb-8 border border-accent/20" data-id="element-215">
        <div className="bg-gradient-to-r from-primary to-[#4A7566] p-6 text-center text-white relative overflow-hidden" data-id="element-216">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-217"></div>
          <p className="text-accent font-bold tracking-widest text-sm mb-2 uppercase" data-id="element-218">
            Hígado Vital
          </p>
          <h3 className="font-serif text-2xl md:text-3xl font-bold mb-4" data-id="element-219">
            El Protocolo de Drenaje y Recarga
          </h3>
          <p className="font-sans text-lg text-white/90 italic max-w-md mx-auto" data-id="element-220">
            "Desinflama tu Cuerpo y Recupera tu Energía en 14 Días desde
            Adentro"
          </p>
        </div>

        <div className="p-5 md:p-8" data-id="element-221">
          <div className="flex justify-center mb-6" data-id="element-222">
            <img src="https://cdn.magicpatterns.com/uploads/5jZtauBWy7jRReAWi6FdM1/Higado_-_14_dias_.png" alt="Protocolo Hígado Vital" className="w-full max-w-sm rounded-xl shadow-lg" data-id="element-223" />
          </div>

          <p className="text-center font-sans text-lg text-gray-700 mb-6 max-w-lg mx-auto" data-id="element-224">
            No es una dieta. No es un suplemento. No es otro plan de ejercicios.
            Es un protocolo biológico de dos fases diseñado para trabajar con la
            inteligencia natural de tu cuerpo:
          </p>

          <div className="space-y-6" data-id="element-225">
            {/* FASE 1 */}
            <div className="bg-warmWhite p-5 md:p-6 rounded-2xl border border-gray-200 relative" data-id="element-226">
              <div className="absolute -top-4 left-6 bg-accent text-dark font-bold px-4 py-1 rounded-full text-sm shadow-sm" data-id="element-227">
                Días 1-7
              </div>
              <h4 className="font-serif text-2xl font-bold text-dark mt-2 mb-2 flex items-center gap-2" data-id="element-228">
                ⚡ FASE 1: DRENAJE
              </h4>
              <p className="text-primary font-medium italic mb-4" data-id="element-229">
                "Vaciar el filtro tapado"
              </p>
              <p className="font-sans text-gray-700 mb-4" data-id="element-230">
                Eliminamos estratégicamente los tres bloqueadores hepáticos
                principales. No pasas hambre. No cuentas calorías. Solo cambias
                lo que tapa tu hígado por lo que lo desatasca.
              </p>
              <div className="bg-white p-5 rounded-xl border border-gray-100" data-id="element-231">
                <p className="font-bold text-sm text-gray-500 uppercase tracking-wider mb-3" data-id="element-232">
                  Lo que notarás al día 7:
                </p>
                <ul className="space-y-3" data-id="element-233">
                  <li className="flex items-start gap-3" data-id="element-234">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-235" />
                    <span className="text-gray-800" data-id="element-236">
                      Menos presión y pesadez abdominal
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-237">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-238" />
                    <span className="text-gray-800" data-id="element-239">
                      Desaparición del sabor amargo de la mañana
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-240">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-241" />
                    <span className="text-gray-800" data-id="element-242">
                      Primera señal de energía real sin depender del café
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* FASE 2 */}
            <div className="bg-warmWhite p-5 md:p-6 rounded-2xl border border-gray-200 relative" data-id="element-243">
              <div className="absolute -top-4 left-6 bg-accent text-dark font-bold px-4 py-1 rounded-full text-sm shadow-sm" data-id="element-244">
                Días 8-14
              </div>
              <h4 className="font-serif text-2xl font-bold text-dark mt-2 mb-2 flex items-center gap-2" data-id="element-245">
                ⚡ FASE 2: RECARGA
              </h4>
              <p className="text-primary font-medium italic mb-4" data-id="element-246">
                "Encender la batería apagada"
              </p>
              <p className="font-sans text-gray-700 mb-4" data-id="element-247">
                Reintroducimos los precursores del glutatión — el antioxidante
                maestro que tu hígado produce para darte energía celular real.
                Esta es la fase donde pasas de sobrevivir a prosperar.
              </p>
              <div className="bg-white p-5 rounded-xl border border-gray-100" data-id="element-248">
                <p className="font-bold text-sm text-gray-500 uppercase tracking-wider mb-3" data-id="element-249">
                  Lo que notarás al día 14:
                </p>
                <ul className="space-y-3" data-id="element-250">
                  <li className="flex items-start gap-3" data-id="element-251">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-252" />
                    <span className="text-gray-800" data-id="element-253">
                      Energía estable de mañana a noche
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-254">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-255" />
                    <span className="text-gray-800" data-id="element-256">
                      Claridad mental sin niebla cerebral
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-257">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-258" />
                    <span className="text-gray-800" data-id="element-259">
                      Ropa que cierra con menos esfuerzo
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-260">
                    <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-261" />
                    <span className="text-gray-800" data-id="element-262">
                      Piel más luminosa y descansada
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-md mx-auto" data-id="element-263">
        <CTAButton data-id="element-264" />
      </div>
    </SectionWrapper>;
}